import { useState } from 'react';

export const useReferWithoutDoctor = () => {
	const [step, setStep] = useState<number>(0);

	const handleContinue = () => {
		setStep(step + 1);
	};

	const handleDownload = () => {
		fetch(
			'https://welbe-shared-email-assets.s3.amazonaws.com/company/carta-modelo-derivacion.pdf',
		).then((response) => {
			response
				.blob()
				.then((blob) => {
					const fileURL = window.URL.createObjectURL(blob);
					const alink = document.createElement('a');
					alink.id = 'download';
					alink.href = fileURL;
					alink.download = 'carta-derivacion.pdf';
					alink.click();
				})
				.then(() => {
					document.getElementById('download')?.remove();
				});
		});
	};

	return {
		step,
		handleContinue,
		handleDownload,
	};
};
